import PrimaryButton from "library/Atoms/Button/PrimaryButton";
import ModalLayout from "library/Layouts/ModalLayout";
import PropTypes from "prop-types";
import DefaultModal from "../DefaultModal";

const AlertModal = ({ id, title, description, onClose, onConfirm, closeBtnText, isDataProcessing, ...restProps }) => (
  <DefaultModal id={id} title={title} onClose={onClose} {...restProps}>
    <ModalLayout
      modalControls={
        <PrimaryButton
          id="alert-close-btn"
          className="w-100"
          label={closeBtnText}
          onClick={onConfirm}
          loading={isDataProcessing}
        />
      }
    >
      {description}
    </ModalLayout>
  </DefaultModal>
);

AlertModal.defaultProps = {
  id: null,
  title: null,
  description: null,
  closeBtnText: null,
  onClose: () => {},
  isDataProcessing: false,
};

AlertModal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  closeBtnText: PropTypes.string,
  isDataProcessing: PropTypes.bool,
};

export default AlertModal;
